<template>
    <div id="app" v-if="loaded">
        <div v-if="header_is_visible" class="header_wrapper">
            <Header/>
        </div>
        <div>
            <router-view/>
        </div>
        <Help/>
    </div>
</template>

<script>
    import { mapState, mapActions } from 'vuex'
    import Header from './components/Header'
    import Help from './components/Help'

    export default {
        name: 'app',
        components: { Header, Help },
        data: () => ({
            loaded: false,
        }),
        async created() {
            await this.init();
            //マイページに直アドレスでアクセスされた場合はトップページへリダイレクトする
            if ( /^\/mypage/.test( this.$route.path ) && this.user_data.id === -1 ) {
                await this.$router.replace('/');
            }
            this.loaded = true;
        },
        computed: {
            ...mapState(["user_data"]),
            header_is_visible: _this => {
                return !( /^\/mypage/.test( _this.$route.path ) );
            }
        },
        methods: {
            ...mapActions(["init"]),
        },
    }
</script>

<style lang="scss">
    #app{
        font-family: "Helvetica Neue", Arial, "Hiragino Kaku Gothic ProN", "Hiragino Sans", Meiryo, sans-serif !important;
        line-height: 1.5;
        font-weight: normal;
        position: relative;
        /*padding-bottom: 200px;*/
        z-index: 900;
        [src$=".svg"], [data$=".svg"] {
            width: auto;
        }
    }

    /* 　▼PCとSPで画像の表示切替▼　*/
    .pc {
        display: block!important;
    }
    .sp {
        display: none!important;
    }
    a{
        text-decoration: none;
    }

    .myhome_sukikamo {
        opacity: 1;
    }
    .help_btn{
        opacity: 1;
    }
    .myhome_sukikamo.fade-out {
        opacity: 0;
        transition: opacity 1s;
    }
    .help_btn.fade-out {
        opacity: 0;
        transition: opacity 1s;
    }

    @media only screen and (max-width: 639px) {
        .pc {
            display: none !important;
        }
        .sp {
            display: block !important;
        }

        .room_card {
            .favorite {
                /*z-index: 1;*/
            }
        }
        .add_sukikamo_list {
            z-index: 10;
        }
    }
</style>
